import React, { Component, useState } from "react";
import { Switch, TextField, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

// import { Row, Col, Card, Input, CardBody, FormGroup, Button, Label, Badge, } from "reactstrap";
import { connect } from "react-redux";
import { hideLoader, showLoader } from "../../../../redux/actions/loader-data";
import { ToastsStore } from "react-toasts";
import moment from "moment";
import { deepClone } from "../../../../helper-methods";
import {
  getAllFilesList,
  getAllImagesList,
  createVmTemplate,
} from "../../../../http/http-calls";
import config from "../../../../config";
import { template } from "lodash";
// import Select from "react-dropdown-select";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import Typography from '@mui/material/Typography';
import Chip from "@mui/material/Chip";
// import Switch from '@mui/material/Switch';
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const StyledOption = styled.span`
  padding: 0;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  transition: all 1s ease-in;

  span {
    display: none;
    transition: all 1s ease-in;
  }
  a {
    margin: 0 5px;
  }
  :hover {
    background: #f2f2f2;
    span {
      display: inline;
      margin: 0 0 0 5px;
      color: red;
    }
  }
`;
const StyledItem = styled.div`
  padding: 10px;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;
  :hover {
    background: #f2f2f2;
  }
`;

const FieldManager = ({ onUpdate }) => {
  const [fields, setFields] = useState([]);

  const handleAddField = () => {
    const newField = {
      _id: uuidv4(),
      dataType: "String",
      isEditable: false,
      isMandatory: false,
      fieldName: "",
      label: "",
      defaultValue: "",
    };
    const updatedFields = [...fields, newField];
    setFields(updatedFields);

    // Update the parent component's state
    onUpdate(updatedFields);
  };

  const handleFieldChange = (id, key, value) => {
    const updatedFields = fields.map((field) =>
      field._id === id ? { ...field, [key]: value } : field,
    );
    setFields(updatedFields);

    // Update the parent component's state
    onUpdate(updatedFields);
  };

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginTop: "30px" }}></div>
      {fields.map((field) => (
        <div
          key={field._id}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="Field Name"
            value={field.fieldName}
            onChange={(e) =>
              handleFieldChange(field._id, "fieldName", e.target.value)
            }
            style={{ flex: "1 1 calc(33.33% - 10px)" }}
            InputProps={{
              style: { color: "#aaa" }, // Light gray input text
            }}
            InputLabelProps={{
              style: { color: "#888" }, // Gray label by default
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "gray", // Default border color
                },
                "&:hover fieldset": {
                  borderColor: "#666", // Darker gray on hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#888", // Distinct gray on focus
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#666", // Darker gray label on focus
                },
              },
            }}
          />
          <TextField
            label="Default Value"
            value={field.defaultValue}
            onChange={(e) =>
              handleFieldChange(field._id, "defaultValue", e.target.value)
            }
            style={{ flex: "1 1 calc(33.33% - 10px)" }}
            InputProps={{
              style: { color: "#aaa" },
            }}
            InputLabelProps={{
              style: { color: "#888" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "gray",
                },
                "&:hover fieldset": {
                  borderColor: "#666",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#888",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#666",
                },
              },
            }}
          />
          <TextField
            label="Label"
            value={field.label}
            onChange={(e) =>
              handleFieldChange(field._id, "label", e.target.value)
            }
            style={{ flex: "1 1 calc(33.33% - 10px)" }}
            InputProps={{
              style: { color: "#aaa" },
            }}
            InputLabelProps={{
              style: { color: "#888" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "gray",
                },
                "&:hover fieldset": {
                  borderColor: "#666",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#888",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#666",
                },
              },
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              color: "lightgray",
            }}
          >
            <Switch
              checked={field.isEditable}
              onChange={(e) =>
                handleFieldChange(field._id, "isEditable", e.target.checked)
              }
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#F18F3C", // Thumb color when toggled on
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#F18F3C", // Track color when toggled on
                },
              }}
            />
            Editable
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              color: "lightgray",
            }}
          >
            <Switch
              checked={field.isMandatory}
              onChange={(e) =>
                handleFieldChange(field._id, "isMandatory", e.target.checked)
              }
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#F18F3C",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#F18F3C",
                },
              }}
            />
            Mandatory
          </div>
        </div>
      ))}
      <div style={{ textAlign: "right", marginTop: "20px" }}>
        <Button
          variant="text"
          style={{
            background: "none",
            color: "#F18F3C",
          }}
          onClick={handleAddField}
        >
          <AddIcon />
          Add Field
        </Button>
      </div>
    </div>
  );
};

class TemplateCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 1,
      input: false,
      template: {
        name: "",
        description: "",
        baseBin: "virsh",
        vmimage: [],
        dockertext: "",
        dockerimage: [],
        textArea: "",
        defaulticon: "",
        defaultvmimage: "",
        requiresSecondaryDisk: false,
        pictureId: [],
        active: false,
      },
      tempDefaultvalue: "",
      fieldsToShow: [],
      vmTemplates: deepClone(config.vmTemplateFields),
      isDirtyTemplate: {
        name: false,
        baseBin: false,
        vmimage: false,
        textArea: false,
        pictureId: false,
      },
      errors: {},
      currentPage: 1,
      totalPages: "",
      searchItem: "",
      imageList: [],
      iconList: [],
      selectedFile: null,
      previewImg: null,
      selectedIcons: [],
    };
  }
  componentDidMount = () => {
    this._getAllImage();
    this._getAllIcons();
  };
  //changing format of createdAt
  _changeFormat = (data) => {
    return moment(data).format("MMM DD, hh:mm a");
  };
  //for pagination
  _paginate = (pageNumber) => {
    this._getTeamsList(pageNumber);
  };
  // To get the Image assets
  _getAllImage = async () => {
    let res = await getAllImagesList();
    console.log("res :>> ", res);
    this.setState({ imageList: res.files });
  };
  // To get the icon assets
  _getAllIcons = async () => {
    let res = await getAllFilesList({ isIcon: true });
    console.log("res :>> ", res);
    this.setState({ iconList: res.files });
  };
  // handleChange
  handleChange = () => {
    let tempFieldsToShow = this.state.fieldsToShow.filter(
      (each) => each.isSelected !== undefined && each.isSelected !== false,
    );
    // tempFieldsToShow.forEach(it=>delete it.type);
    console.log(tempFieldsToShow);
    this.setState(
      { input: !this.state.input, fieldsToShow: tempFieldsToShow },
      () => {
        // this._handleOnChange(
        // "textArea",
        // JSON.stringify(this.state.fieldsToShow)
        // )
        // console.log(!this.state.input,template.textArea=="[]")
        // if(!this.state.input&&template.textArea!==`[]`){
        // console.log(JSON.parse(template.textArea))
        // this.setState({
        // fieldsToShow:JSON.parse(template.textArea)
        // })
        // }
        if (!this.state.input && template.textArea !== `[]`) {
          this.fieldsToShowUpdating();
        } else {
          this._handleOnChange(
            "textArea",
            JSON.stringify(this.state.fieldsToShow, undefined, 2),
          );
        }
      },
    );
    // this.setState({ fieldsToShow: tempFieldsToShow });
  };
  fieldsToShowUpdating = () => {
    let { vmTemplates } = this.state;
    console.log(JSON.parse(this.state.template.textArea));
    this.setState(
      {
        fieldsToShow: JSON.parse(this.state.template.textArea),
      },
      () => {
        let updatedVmTemplates = vmTemplates.map(
          (obj) =>
            JSON.parse(this.state.template.textArea).find(
              // eslint-disable-next-line
              (o) => o.fieldName == obj.fieldName,
            ) || obj,
        );
        this.setState({ vmTemplates: updatedVmTemplates });
      },
    );
  };
  //handling input here
  _handleOnChange = (field, value) => {
    console.log(field, value);
    const { template, isDirtyTemplate } = this.state;
    // template[field] = value;
    // isDirtyTemplate[field] = true;
    // this.setState({ template });
    // this.setState({ template }, () => {
    // console.log(isDirtyTemplate[field], field);
    // if (isDirtyTemplate[field]) this._validationTemplate(value);
    // });
    // eslint-disable-next-line
    if (field == "baseBin") {
      this.setState(
        {
          template: {
            ...this.state.template,
            [field]: value,
            defaultvmimage: "",
            vmimage: [],
            dockerimage: [],
          },
          fieldsToShow: [],
          vmTemplates: deepClone(config.vmTemplateFields),
        },
        () => {
          console.log(isDirtyTemplate[field], field);
          if (isDirtyTemplate[field]) this._validationTemplate(value);
        },
      );
      // eslint-disable-next-line
    } else if (field == "vmimage" || field == "dockerimage") {
      this.setState(
        {
          template: {
            ...this.state.template,
            vmimage:
              // eslint-disable-next-line
              field == "vmimage"
                ? this.state.template.vmimage.concat([value])
                : [],
            dockerimage:
              // eslint-disable-next-line
              field == "dockerimage"
                ? [...new Set(this.state.template.dockerimage.concat([value]))]
                : [],
            dockertext: "",
          },
        },
        () => {
          console.log(isDirtyTemplate[field], field);
          if (isDirtyTemplate[field]) this._validationTemplate(value);
        },
      );
    } else {
      template[field] = value;
      this.setState({ template }, () => {
        console.log(isDirtyTemplate[field], field);
        if (isDirtyTemplate[field]) this._validationTemplate(value);
      });
    }
  };
  markDirty = (fieldName, fieldvalue) => {
    const { isDirtyTemplate } = this.state;
    console.log(fieldName);
    isDirtyTemplate[fieldName] = true;
    this.setState(
      { isDirtyTemplate },
      () => console.log(isDirtyTemplate),
      this._validationTemplate(fieldvalue),
    );
    // console.log(this.state.errors,this.state.isDirtyTemplate);
  };
  _validationTemplate = (value) => {
    const { template, errors, isDirtyTemplate } = this.state;
    console.log("object");
    Object.keys(template).forEach((each) => {
      if (each === "name" && isDirtyTemplate.name) {
        if (!template.name.trim().length) {
          errors.nameTemplate = "Name is Required";
        } else {
          delete errors["nameTemplate"];
          isDirtyTemplate.name = false;
        }
      } else if (each === "baseBin" && isDirtyTemplate.baseBin) {
        if (!template.baseBin.trim().length) {
          errors.baseBin = "VM Type is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.baseBin = false;
        }
      } else if (each === "vmimage" && isDirtyTemplate.vmimage) {
        // eslint-disable-next-line
        if (!template.vmimage.length > 0 && template.baseBin == "virsh") {
          errors.vmimage = "VM Image is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.vmimage = false;
        }
      } else if (each === "dockerimage" && isDirtyTemplate.dockerimage) {
        // eslint-disable-next-line
        if (!template.dockerimage.length > 0 && template.baseBin == "docker") {
          errors.dockerimage = "Docker Image is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.dockerimage = false;
        }
      } else if (
        // eslint-disable-next-line
        each == "textArea" &&
        this.state.input &&
        isDirtyTemplate.textArea
      ) {
        console.log(value);
        // let data= JSON.stringify(value, undefined, 0)
        try {
          JSON.parse(value);
          delete errors[each];
          isDirtyTemplate.textArea = false;
        } catch {
          console.log("error");
          errors.textArea = "Not a Valid Json";
        }
      }
    });
    if (
      isDirtyTemplate.selectedFile &&
      !this.state.selectedFile &&
      !this.state.selectedIcons.length
    ) {
      errors.selectedFile = "*Select OR Upload an Icon";
    } else if (
      isDirtyTemplate.selectedFile &&
      this.state.selectedFile &&
      !config.supportedFileFormats.includes(this.state.selectedFile.type)
    ) {
      errors.selectedFile = "Please select an image file";
    } else {
      delete errors.selectedFile;
    }
    this.setState({ errors });
    console.log("err", this.state.errors);
    return Object.keys(errors).length ? errors : {};
  };
  _Template = () => {
    let isDirtyTemplate = {
      name: true,
      baseBin: true,
      vmimage: true,
      dockerimage: true,
    };
    this.setState({ isDirtyTemplate }, () => {
      // eslint-disable-next-line
      let arrayDataType = this.state.fieldsToShow
        .filter((item) => item.dataType == "Array")
        .map(
          (each) =>
            each?.defaultValue !== undefined &&
            this.checkArrayHasDuplicate(each?.defaultValue.split(",")),
        );
      console.log(arrayDataType.includes(true));
      let errors = this._validationTemplate();
      console.log(
        JSON.stringify(errors) === "{}" && !arrayDataType.includes(true),
      );
      if (JSON.stringify(errors) === "{}" && !arrayDataType.includes(true)) {
        let { template, fieldsToShow } = this.state;
        console.error("========");
        console.error(fieldsToShow);
        console.error("========");
        let fieldstoSend = fieldsToShow
          .filter(
            (each) =>
              each.isSelected !== undefined && each.isSelected !== false,
          )
          .map((item) => ({
            dataType: item.dataType,
            isEditable: item.isEditable,
            isMandatory: item.isMandatory,
            fieldName: item.fieldName,
            label: item.label,
            defaultValue:
              // eslint-disable-next-line
              item.dataType == "Number"
                ? Number(item.defaultValue)
                : // eslint-disable-next-line
                  item.dataType == "Array"
                  ? item.defaultValue.split(",")
                  : item.defaultValue,
          }));
        fieldsToShow = this.state.fieldsToShow.map(({ _id, ...rest }) => rest);
        let data = {
          name: template.name,
          templateVersion: "2.0",
          description: template.description,
          baseBin: template.baseBin,
          imagesToShow:
            template.vmimage.length > 0 ? template.vmimage : undefined,
          dockerImagesToShow:
            template.dockerimage.length > 0 ? template.dockerimage : undefined,
          defaultIconId: template?.pictureId[0]?.id,
          defaultVMImageId:
            // eslint-disable-next-line
            template.baseBin == "virsh" ? template.defaultvmimage : undefined,
          defaultDockerImage:
            // eslint-disable-next-line
            template.baseBin == "docker" ? template.defaultvmimage : undefined,
          fieldsToShow: fieldsToShow,
          // fieldsToShow: fieldstoSend.length > 0 ? fieldstoSend : undefined,
          isActive: template.active,
          requiresSecondaryDisk: template.requiresSecondaryDisk,
        };

        console.error("this is the final fieldToShow without ic", fieldsToShow);
        console.error("this is the final data", data);
        console.log(data);
        createVmTemplate(data)
          .then((resp) => {
            this.setState({
              template: {
                name: "",
                description: "",
                baseBin: "virsh",
                vmimage: [],
                dockerimage: [],
                textArea: "",
                defaulticon: "",
                defaultvmimage: "",
                requiresSecondaryDisk: false,
                pictureId: [],
                active: false,
              },
              isDirtyTemplate: {
                name: false,
                baseBin: false,
                vmimage: false,
                textArea: false,
                pictureId: false,
              },
            });
            this.props.hideLoader();
            ToastsStore.success("VM Template Created successfully");
          })
          .catch((error) => {
            console.log("error :", error);
            this.props.hideLoader();
            ToastsStore.error("VM Template Creation Error:- " + error.reason);
          });
      }
    });
  };

  updateFieldsToShow = (newFields) => {
    this.setState({ fieldsToShow: newFields });
  };

  _fieldOnChange = (fieldName, fieldValue, item) => {
    console.error(fieldName, fieldValue);
    const { fieldsToShow } = this.state;
    // this.setState({ fieldsToShow: updatedfieldtoShow });
    // fieldsToShow = [...this.state.fieldsToShow, { fieldName, fieldValue }]
    // this.setState({ fieldsToShow: { ...this.state.fieldsToShow } })
    console.error("this is the valuie", fieldName, fieldValue);
    this.setState({
      fieldsToShow: [
        ...this.state.fieldsToShow,
        {
          dataType: "String",
          [fieldName]: fieldValue,
          isMandatory: false,
          isEditable: false,
        },
      ],
    });
    // console.log('this is the final', this.state.fieldsToShow)
    // // console.error(fieldsToShow, 'this is the fierslhjkjhafs')
    // if (fieldsToShow.length > 0) {
    //   let objIndex = fieldsToShow.findIndex(
    //     (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
    //   );
    //   if (objIndex >= 0) {
    //     // this.setState({fieldsToShow:[...this.state.fieldsToShow,{...fieldsToShow[a],[fieldName]:fieldValue}]})
    //     const updatedObj = {
    //       ...fieldsToShow[objIndex],
    //       [fieldName]: fieldValue,
    //     };
    //     const updatedfieldtoShow = [
    //       ...fieldsToShow.slice(0, objIndex),
    //       updatedObj,
    //       ...fieldsToShow.slice(objIndex + 1),
    //     ];
    //     console.log(updatedfieldtoShow);
    //     // this.setState({ fieldsToShow: updatedfieldtoShow });
    //   } else {
    //     // this.setState({
    //     // fieldsToShow: [
    //     // ...this.state.fieldsToShow,
    //     // {
    //     // ...item,
    //     // [fieldName]: fieldValue,
    //     // isMandatory: false,
    //     // isEditable: false,
    //     // },
    //     // ],
    //     // });
    //   }
    // } else {
    //   this.setState({
    //     fieldsToShow: [
    //       ...this.state.fieldsToShow,
    //       {
    //         ...item,
    //         [fieldName]: fieldValue,
    //         isMandatory: false,
    //         isEditable: false,
    //       },
    //     ],
    //   });
    // }
    // this._updateTemplate(fieldName, fieldValue, item);
  };
  _updateTemplate = (fieldName, fieldValue, item) => {
    const { vmTemplates } = this.state;
    let objIndex = vmTemplates.findIndex(
      (o) => o.fieldName === item.fieldName && o.dataType === item.dataType,
    );
    if (objIndex >= 0) {
      // this.setState({fieldsToShow:[...this.state.fieldsToShow,{...fieldsToShow[a],[fieldName]:fieldValue}]})
      const updatedObj = {
        ...vmTemplates[objIndex],
        [fieldName]: fieldValue,
      };
      const updatedfieldtoShow = [
        ...vmTemplates.slice(0, objIndex),
        updatedObj,
        ...vmTemplates.slice(objIndex + 1),
      ];
      this.setState({ vmTemplates: updatedfieldtoShow });
    }
  };
  _customOptionRenderer = ({ item, props, state, methods }) => {
    console.log(item);
    return (
      <StyledOption>
        <img src={item.url} width={30} alt={item.name} />
        &nbsp;
        {item.name}
        <span
          onClick={() => {
            methods.removeItem(null, item);
            this.setState({ selectedIcons: [] }, () => {
              this._validateFields();
            });
          }}
        >
          &times;
        </span>
      </StyledOption>
    );
  };
  _customItemRenderer = ({ item, itemIndex, props, state, methods }) => {
    const { selectedIcons } = deepClone(this.state);
    console.log(item);
    return (
      <StyledItem>
        <div
          onClick={() => {
            console.log("selectedIcons :>> ", item);
            methods.addItem(item);
            const { isDirtyTemplate } = deepClone(this.state);
            isDirtyTemplate.pictureId = true;
            const isAlreadyPresent =
              selectedIcons.length && selectedIcons[0].id === item.id;
            this.setState(
              {
                selectedIcons: isAlreadyPresent ? [] : [item],
                selectedFile: null,
                previewImg: null,
                isDirtyTemplate,
              },
              () => {
                this._validationTemplate();
              },
            );
          }}
        >
          <img src={item.url} width={30} alt={item.name} /> &nbsp;
          {item.name}
        </div>
      </StyledItem>
    );
  };
  _handleOnDelete = (value) => {
    console.log(value);
    let list = this.state.template.vmimage.filter((each) => each !== value);
    console.log(list);
    this.setState({
      template: {
        ...this.state.template,
        vmimage: list,
      },
    });
  };
  _handleOnDockerDelete = (value) => {
    let list = this.state.template.dockerimage.filter((each) => each !== value);
    console.log(list);
    this.setState({
      template: {
        ...this.state.template,
        dockerimage: list,
      },
    });
  };
  checkArrayHasDuplicate = (arr) => {
    console.log(arr);
    // eslint-disable-next-line
    let duplicates = arr.filter((item, index) => arr.indexOf(item) != index);
    return duplicates.length > 0 ? true : false;
  };
  // _fieldOnDefaultChange = (fieldName, fieldValue, item, index) => {
  // console.log(fieldName, fieldValue, item);
  // const { fieldsToShow } = this.state;
  // let objIndex = fieldsToShow.findIndex(
  // (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  // );
  // const updatedObj = {
  // ...fieldsToShow[objIndex],
  // [fieldName]: fieldsToShow[objIndex].defaultValue
  // ? [...fieldsToShow[objIndex].defaultValue, fieldValue]
  // : [fieldValue],
  // };
  // const updatedfieldtoShow = [
  // ...fieldsToShow.slice(0, objIndex),
  // updatedObj,
  // ...fieldsToShow.slice(objIndex + 1),
  // ];
  // console.log(updatedfieldtoShow);
  // this.setState(
  // { fieldsToShow: updatedfieldtoShow, tempDefaultvalue: "" },
  // () =>
  // this._fieldOnDefaultChangeUpdateVmtemplate(
  // fieldName,
  // fieldValue,
  // item,
  // index
  // )
  // );
  // };
  // _fieldOnDefaultChangeUpdateVmtemplate = (
  // fieldName,
  // fieldValue,
  // item,
  // index
  // ) => {
  // console.log(fieldName, fieldValue, item);
  // const { vmTemplates } = this.state;
  // let objIndex = vmTemplates.findIndex(
  // (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  // );
  // const updatedObj = {
  // ...vmTemplates[objIndex],
  // [fieldName]: vmTemplates[objIndex].defaultValue
  // ? [...vmTemplates[objIndex].defaultValue, fieldValue]
  // : [fieldValue],
  // };
  // const updatedfieldtoShow = [
  // ...vmTemplates.slice(0, objIndex),
  // updatedObj,
  // ...vmTemplates.slice(objIndex + 1),
  // ];
  // console.log(updatedfieldtoShow);
  // this.setState({ vmTemplates: updatedfieldtoShow });
  // };
  // _handleOnDefaultvalueDelete = (item, each) => {
  // console.log(item, each);
  // const { fieldsToShow } = this.state;
  // let objIndex = fieldsToShow.findIndex(
  // (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  // );
  // const updatedObj = {
  // ...fieldsToShow[objIndex],
  // defaultValue: fieldsToShow[objIndex].defaultValue.filter(
  // (item) => item !== each
  // ),
  // };
  // const updatedfieldtoShow = [
  // ...fieldsToShow.slice(0, objIndex),
  // updatedObj,
  // ...fieldsToShow.slice(objIndex + 1),
  // ];
  // this.setState({ fieldsToShow: updatedfieldtoShow }, () =>
  // this._handleOnDefaultvalueDeleteVmtemplate(item, each)
  // );
  // };
  // _handleOnDefaultvalueDeleteVmtemplate = (item, each) => {
  // const { vmTemplates } = this.state;
  // let objIndex = vmTemplates.findIndex(
  // (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  // );
  // const updatedObj = {
  // ...vmTemplates[objIndex],
  // defaultValue: vmTemplates[objIndex].defaultValue.filter(
  // (item) => item !== each
  // ),
  // };
  // const updatedfieldtoShow = [
  // ...vmTemplates.slice(0, objIndex),
  // updatedObj,
  // ...vmTemplates.slice(objIndex + 1),
  // ];
  // this.setState({ vmTemplates: updatedfieldtoShow });
  // };
  render() {
    console.log(this.state);
    const { errors, template } = deepClone(this.state);
    let VmTemplate = this.state.vmTemplates.filter(
      (i) =>
        // eslint-disable-next-line
        i.type[0] == this.state.template.baseBin ||
        // eslint-disable-next-line
        i.type[1] == this.state.template.baseBin,
    );
    console.log(VmTemplate);
    let preView =
      this.state.template.vmimage &&
      this.state.imageList.filter((item) =>
        // eslint-disable-next-line
        this.state.template.vmimage.some((each) => item.id == each),
      );
    let dockerPreView =
      this.state.template.dockerimage &&
      this.state.imageList.filter((item) =>
        // eslint-disable-next-line
        this.state.template.dockerimage.some((each) => item.id == each),
      );
    console.log(dockerPreView);
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              {/* Template Creation */}
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      label="Name*"
                      placeholder="Name"
                      name="name"
                      value={template.name}
                      onChange={(e) =>
                        this._handleOnChange("name", e.target.value)
                      }
                      error={!!errors?.nameTemplate}
                      helperText={errors?.nameTemplate}
                      sx={{
                        input: {
                          color: "lightgray", // Light gray text color
                        },
                        label: {
                          color: "gray", // Gray label color when not focused
                          "&.Mui-focused": {
                            color: "gray", // Gray label color when focused
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "lightgray", // Light gray border when not focused
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "lightgray", // Light gray border when focused
                          },
                          "&:hover fieldset": {
                            borderColor: "lightgray", // Keep light gray border color on hover
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      label="VM Type*"
                      placeholder="VM Type"
                      name="baseBin"
                      value={template.baseBin}
                      onChange={(e) =>
                        this._handleOnChange("baseBin", e.target.value)
                      }
                      error={!!errors?.baseBin}
                      helperText={errors?.baseBin}
                      sx={{
                        input: {
                          color: "lightgray", // Light gray text color
                        },
                        label: {
                          color: "gray", // Gray label color when not focused
                          "&.Mui-focused": {
                            color: "gray", // Gray label color when focused
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "lightgray", // Light gray border when not focused
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "lightgray", // Light gray border when focused
                          },
                          "&:hover fieldset": {
                            borderColor: "lightgray", // Keep light gray border color on hover
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={12}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      label="Description"
                      placeholder="Description"
                      name="description"
                      value={template.description}
                      onChange={(e) =>
                        this._handleOnChange("description", e.target.value)
                      }
                      multiline
                      rows={3}
                      sx={{
                        input: {
                          color: "lightgray", // Light gray text color for text inside the input
                        },
                        label: {
                          color: "gray", // Gray label color when not focused
                          "&.Mui-focused": {
                            color: "gray", // Gray label color when focused
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "lightgray", // Light gray border when not focused
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "lightgray", // Light gray border when focused
                          },
                          "& textarea": {
                            color: "lightgray", // Ensure that text color for textarea is light gray
                          },
                          "&:hover fieldset": {
                            borderColor: "lightgray", // Keep light gray border color on hover
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  {template.baseBin === "docker" ? (
                    <TextField
                      fullWidth
                      label="Docker Images*"
                      placeholder="Enter Docker Images and Press Enter Key"
                      value={template.dockertext}
                      onChange={(e) =>
                        this.setState({
                          template: {
                            ...this.state.template,
                            dockertext: e.target.value,
                          },
                        })
                      }
                      onKeyPress={(e) =>
                        e.key === "Enter" &&
                        e.target.value.trim() !== "" &&
                        this._handleOnChange("dockerimage", e.target.value)
                      }
                      sx={{
                        input: {
                          color: "lightgray", // Light gray text color
                        },
                        label: {
                          color: "gray", // Gray label color when not focused
                          "&.Mui-focused": {
                            color: "gray", // Gray label color when focused
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "lightgray", // Light gray border when not focused
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "lightgray", // Light gray border when focused
                          },
                          "&:hover fieldset": {
                            borderColor: "lightgray", // Keep light gray border color on hover
                          },
                        },
                      }}
                    />
                  ) : (
                    <FormControl fullWidth>
                      <InputLabel
                        sx={{
                          color: "gray", // Gray label color
                          "&.Mui-focused": {
                            color: "gray", // Gray label color when focused
                          },
                        }}
                      >
                        VM Images
                      </InputLabel>
                      <Select
                        value={this.state.template.vmimage}
                        onChange={(e) =>
                          this._handleOnChange("vmimage", e.target.value)
                        }
                        label="VM Images"
                        sx={{
                          color: "lightgray", // Light gray text color
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "lightgray", // Default border color
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "lightgray", // Keep border color when focused
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "lightgray", // Hover border color
                          },
                          "& .MuiSelect-icon": {
                            color: "lightgray", // Light gray icon color
                          },
                          "& .MuiMenu-paper": {
                            backgroundColor: "gray", // Gray background for the dropdown menu
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              backgroundColor: "gray", // Customize menu background
                            },
                          },
                        }}
                      >
                        <MenuItem sx={{ color: "lightgray" }} value="">
                          Select here
                        </MenuItem>
                        {this.state.imageList?.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            sx={{ color: "lightgray" }}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {errors?.dockerimage && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ display: "block", mt: 1 }}
                    >
                      {errors.dockerimage}
                    </Typography>
                  )}
                  {errors?.vmimage && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ display: "block", mt: 1 }}
                    >
                      {errors.vmimage}
                    </Typography>
                  )}

                  {template.dockerimage?.map((each) => (
                    <Chip
                      label={each}
                      onDelete={() => this._handleOnDockerDelete(each)}
                      sx={{
                        m: 0.5,
                        color: "white", // Text color when not hovered (white)
                        backgroundColor: "gray", // Background color when not hovered
                        borderColor: "lightgray", // Light gray border color
                        "& .MuiChip-deleteIcon": {
                          color: "lightgray", // Light gray color for the delete icon
                        },
                      }}
                    />
                  ))}
                  {preView?.map((each) => (
                    <Chip
                      label={each.name}
                      onDelete={() => this._handleOnDelete(each.id)}
                      sx={{
                        m: 0.5,
                        color: "white", // Text color when not hovered (white)
                        backgroundColor: "gray", // Background color when not hovered
                        borderColor: "lightgray", // Light gray border color
                        "& .MuiChip-deleteIcon": {
                          color: "lightgray", // Light gray color for the delete icon
                        },
                      }}
                    />
                  ))}
                </Grid>

                <Grid item md={6}>
                  <FormControl fullWidth>
                    <InputLabel
                      sx={{
                        color: "gray", // Gray label color
                        "&.Mui-focused": {
                          color: "gray", // Gray label color when focused
                        },
                      }}
                    >
                      Default{" "}
                      {this.state.template.baseBin === "docker"
                        ? "Docker"
                        : "VM"}{" "}
                      Image
                    </InputLabel>

                    <Select
                      value={this.state.template.defaultvmimage}
                      onChange={(e) =>
                        this._handleOnChange("defaultvmimage", e.target.value)
                      }
                      label="Default {this.state.template.baseBin === 'docker' ? 'Docker' : 'VM'} Image" // Ensures label animates
                      sx={{
                        color: "lightgray", // Light gray text color
                        ".MuiOutlinedInput-notchedOutline": {
                          borderColor: "lightgray", // Default border color
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "lightgray", // Keep border color when focused
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "lightgray", // Hover border color
                        },
                        "& .MuiSelect-icon": {
                          color: "lightgray", // Light gray icon color
                        },
                        "& .MuiMenu-paper": {
                          backgroundColor: "gray", // Gray background for the dropdown menu
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: "gray", // Customize menu background
                          },
                        },
                      }}
                    >
                      <MenuItem sx={{ color: "lightgray" }} value="">
                        Select
                      </MenuItem>
                      {preView.map((each) => (
                        <MenuItem
                          key={each.id}
                          value={each.id}
                          sx={{ color: "lightgray" }}
                        >
                          {each.name}
                        </MenuItem>
                      ))}
                      {template.dockerimage.map((each) => (
                        <MenuItem
                          key={each}
                          value={each}
                          sx={{ color: "lightgray" }}
                        >
                          {each}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* <FormControl fullWidth sx={{ width: '100%' }}>
                    <InputLabel
                      shrink={true} // Ensures the label moves up even if no value is selected
                      sx={{
                        color: 'gray', // Gray label color
                        '&.Mui-focused': {
                          color: 'gray', // Gray label color when focused
                        },
                        position: 'absolute',
                        top: '-10px', // Position it above the input when focused
                        left: '14px', // Adjust this according to your design
                        transition: 'all 0.2s ease-in-out', // Smooth transition for label movement
                      }}
                    >
                      Default {this.state.template.baseBin === "docker" ? "Docker" : "VM"} Image
                    </InputLabel>
                    <Select
                      value={this.state.template.defaultvmimage}
                      onChange={(e) =>
                        this._handleOnChange("defaultvmimage", e.target.value)
                      }
                      label="Default {this.state.template.baseBin === 'docker' ? 'Docker' : 'VM'} Image" // Ensures label animates
                      sx={{
                        color: 'lightgray', // Light gray text color
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: 'gray', // Default border color
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'gray', // Keep border color when focused
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'gray', // Hover border color
                        },
                        '& .MuiSelect-icon': {
                          color: 'lightgray', // Light gray icon color
                        },
                        '& .MuiMenu-paper': {
                          backgroundColor: 'gray', // Gray background for the dropdown menu
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: 'gray', // Customize menu background
                          },
                        },
                      }}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {preView.map((each) => (
                        <MenuItem key={each.id} value={each.id} sx={{ color: 'lightgray' }}>
                          {each.name}
                        </MenuItem>
                      ))}
                      {template.dockerimage.map((each) => (
                        <MenuItem key={each} value={each} sx={{ color: 'lightgray' }}>
                          {each}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                </Grid>
                <Grid item md={6}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Switch
                            color="warning"
                            onChange={(e) =>
                              this._handleOnChange("active", e.target.checked)
                            }
                          />
                        }
                        label="Active"
                      />
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Switch
                            color="warning"
                            onChange={(e) =>
                              this._handleOnChange(
                                "requireSecondDisk",
                                e.target.checked,
                              )
                            }
                          />
                        }
                        label="Required Second Disk"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <FieldManager onUpdate={this.updateFieldsToShow} />
              <Grid item xs={12} sx={{ textAlign: "right", mt: 2 }}>
                <Button
                  sx={{
                    background: "#F18F3C",
                  }}
                  variant="contained"
                  onClick={() => this._Template()}
                >
                  Save
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loaderData: state.loaderData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: (loaderData) => dispatch(showLoader(loaderData)),
    hideLoader: (loaderData) => dispatch(hideLoader(loaderData)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TemplateCreation);
